var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.55,
    y: 0.9,
    width: 3.9,
    height: 6.3,
    rx: 1.95,
    fill: "#F2FAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7 6.1C2.7 8.2 4.4 9.7 6.5 9.7C8.6 9.7 10.3 8.2 10.3 6.1",
    stroke: "#F2FAE6",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9.7V11.5",
    stroke: "#F2FAE6",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 11.55H8.6",
    stroke: "#F2FAE6",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicrophone);
export default __webpack_public_path__ + "static/media/ic-microphone.346e1ffe7a7457dcc3a7b77bbefefb09.svg";
export { ForwardRef as ReactComponent };